import { Injectable } from "@angular/core";
import * as moment from "moment";
import { Model_VariableEnvironnementUser } from 'src/app/app.models';
import { PlatformResult, API_RESULT_STATUS } from '../../platform/platform.service';
import { EnvVarUserOfflineDao } from './envvaruser-offline.dao';
import { QueryParams_VariableEnvironnementUser } from 'src/app/pages/views/settings/variable-environment/variable-environment.service';

export interface EnvVarApi {
    doSyncEnvVarsAction(envVarsRaw: string);
    onEnvVarsSynced(_result: PlatformResult);

    doClearEnvVarsAction();
    onEnvVarsCleared(_result: PlatformResult);

    doGetEnvVarsAction(_queryParams: string);
    onEnvVarsFetched(_result: PlatformResult);

    doInsertEnvVarsAction(envVarsRaw: string);
    onEnvVarsInserted(_result: PlatformResult);

    doSaveEnvVarAction(envVar: string);
    onEnvVarSaved(result: PlatformResult);

    doGetEnvVarAction(nomEnvVar: string);
    onEnvVarFetched(result: PlatformResult);
}

@Injectable()
export class EnvVarUserOfflineAndroidDao extends EnvVarUserOfflineDao {
    doSyncEnvironmentVariablesUserAction(_envVars: Model_VariableEnvironnementUser[]): Promise<void> {
        return new Promise((resolve, reject) => {
            window['EnvVarApi'].onEnvVarsSynced = (_result: PlatformResult) => {
                delete window['EnvVarApi'].onEnvVarsSynced;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve();
                } else {
                    reject(_result.error);
                }
            };
            const envVarApi: EnvVarApi = window['EnvVarApi'];
            _envVars.forEach((envVar, index, envVars) => envVars[index].SYNCED = true);
            envVarApi.doSyncEnvVarsAction(JSON.stringify(_envVars))
        });
    }

    doClearEnvironmentVariablesUserAction() {
        return new Promise<void>((resolve, reject) => {
            window['EnvVarApi'].onEnvVarsCleared = (_result: PlatformResult) => {
                delete window['EnvVarApi'].onEnvVarsCleared;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve();
                } else {
                    reject(_result.error);
                }
            };
            const envVarApi: EnvVarApi = window['EnvVarApi'];
            envVarApi.doClearEnvVarsAction()
        });
    }

    doGetEnvironmentVariablesUserAction(_queryParams?: QueryParams_VariableEnvironnementUser): Promise<Model_VariableEnvironnementUser[]> {
        return new Promise<Model_VariableEnvironnementUser[]>((resolve, reject) => {
            window['EnvVarApi'].onEnvVarsFetched = (_result: PlatformResult) => {
                delete window['EnvVarApi'].onEnvVarsFetched;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve(_result.datas);
                } else {
                    reject(_result.error);
                }
            };
            const envVarApi: EnvVarApi = window['EnvVarApi'];
            envVarApi.doGetEnvVarsAction(JSON.stringify(_queryParams));
        });
    }

    doInsertEnvironmentVariablesUserAction(_envVars: Model_VariableEnvironnementUser[]): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            window['EnvVarApi'].onEnvVarsInserted = (_result: PlatformResult) => {
                delete window['EnvVarApi'].onEnvVarsInserted;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve();
                } else {
                    reject(_result.error);
                }
            };
            const envVarApi: EnvVarApi = window['EnvVarApi'];
            envVarApi.doInsertEnvVarsAction(JSON.stringify(_envVars));
        });
    }

    doSaveEnvironmentVariablesUserAction(_envVar: Model_VariableEnvironnementUser): Promise<Model_VariableEnvironnementUser> {
        return new Promise((resolve, reject) => {
            window['EnvVarApi'].onEnvVarSaved = (_result: PlatformResult) => {
                delete window['EnvVarApi'].onEnvVarSaved;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve();
                } else {
                    reject(_result.error);
                }
            };
            const envVarApi: EnvVarApi = window['EnvVarApi'];
            _envVar.DATE_MODIFICATION = moment().format();
            _envVar.SYNCED = false;
            envVarApi.doSaveEnvVarAction(JSON.stringify(_envVar));
        });
    }

    doGetEnvironmentVariableUserAction(_nomVariable: string): Promise<Model_VariableEnvironnementUser> {
        return new Promise((resolve, reject) => {
            window['EnvVarApi'].onEnvVarFetched = (_result: PlatformResult) => {
                delete window['EnvVarApi'].onEnvVarFetched;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve(_result.datas);
                } else {
                    reject(_result.error);
                }
            };
            const envVarApi: EnvVarApi = window['EnvVarApi'];
            envVarApi.doGetEnvVarAction(_nomVariable);
        });
    }
}
